<div class="dialog-info">
  <div
    class="header"
    tabindex="0"
    id="dialogTitle"
    [innerHTML]="header() | textResource | async | safeHtml"
  ></div>

  @if (content()) {
    <div
      class="description"
      tabindex="0"
      #scrollContainer
      [innerHTML]="
        content()
          | textResource
          | async
          | textResourceWithYearParams: kodWniosku()!
          | safeHtml
      "
    ></div>
  } @else {
    <div class="description">
      <ng-container *ngComponentOutlet="component()"></ng-container>
    </div>
  }

  <div class="buttons">
    @if (!hideCancelButton()) {
      <p-button
        [label]="'Anuluj'"
        (click)="dynamicDialogRef.close(false)"
        styleClass="customDangerButton outlined"
        size="small"
      ></p-button>
    }
    @if (!hideSubmitButton()) {
      <p-button
        [label]="'OK'"
        (click)="dynamicDialogRef.close(true)"
        styleClass="customInfoButton"
        size="small"
      ></p-button>
    }
  </div>
</div>
